import FoldersHeader from './FoldersHeader';
import FoldersHeaderContainer from './FoldersHeader.container';

export default FoldersHeaderContainer(FoldersHeader);
